import './sliders';
import './photos';
import './maps';
import './axeptio';
import './animations';
import './calendar';
import './menu';

const checkList = document.getElementById('edit-age--wrapper');
if (checkList !== null) {
  const legend = checkList.getElementsByClassName('fieldset-legend');
  if (legend !== null) {
    legend[0].onclick = function () {
      if (checkList.classList.contains('visible')) {
        checkList.classList.remove('visible');
      } else {
        checkList.classList.add('visible');
      }
    };
  }
}

const checkListb = document.getElementById('edit-field-periode-target-id--wrapper');
if (checkListb !== null) {
  const legend = checkListb.getElementsByClassName('fieldset-legend');
  if (legend !== null) {
    legend[0].onclick = function () {
      if (checkListb.classList.contains('visible')) {
        checkListb.classList.remove('visible');
      } else {
        checkListb.classList.add('visible');
      }
    };
  }
}

const checkListEtranger = document.getElementById('edit-etranger--wrapper');
if (checkListEtranger !== null) {
  const legend = checkListEtranger.getElementsByClassName('fieldset-legend');
  if (legend !== null) {
    legend[0].onclick = function () {
      if (checkListEtranger.classList.contains('visible')) {
        checkListEtranger.classList.remove('visible');
      } else {
        checkListEtranger.classList.add('visible');
      }
    };
  }
}

const start = document.getElementById('edit-dates');
const fin = document.getElementById('edit-fin');

if (start !== null) {
  start.onclick = function () {
    if (checkList.classList.contains('visible')) {
      checkList.classList.remove('visible');
    }
  };
}

if (fin !== null) {
  fin.onclick = function () {
    if (checkList.classList.contains('visible')) {
      checkList.classList.remove('visible');
    }
  };
}
